<template>
  <div>
    <div
      v-for="(register, index) in list"
      :key="index"
      class="bg-white p-3 rounded my-2"
    >
      <div class="row">
        <div v-if="register.info.name" class="col-md-3 col-lg-3">
          <div class="label">
            {{ register.info.name.label }}
          </div>
          <div class="value">{{ register.info.name.value }}</div>
        </div>
        <div
          v-if="register.info.document"
          class="col-md-2 col-lg-2 mt-3 mt-md-0"
        >
          <div class="label">{{ register.info.document.label }}</div>
          <div class="value">{{ register.info.document.value }}</div>
        </div>
        <div
          v-if="register.info.responsavel"
          class="col-md-4 col-lg-4 mt-3 mt-md-0"
        >
          <div class="label">{{ register.info.responsavel.label }}</div>
          <div class="value">{{ register.info.responsavel.value }}</div>
        </div>
        <div v-if="register.info.plan" class="col-md-2 col-lg-3 mt-3 mt-md-0">
          <div class="label">{{ register.info.plan.label }}</div>
          <div class="label mb-0">
            {{ register.info.plan.value }}
          </div>
        </div>
        <div v-if="register.info.status" class="col-md-3 col-lg-3 mt-3 mt-md-0">
          <div class="label">{{ register.info.status.label }}</div>
          <router-link
            :class="`btn btn-sm btn-${register.info.status.class}`"
            :to="register.info.status.link"
            v-if="register.info.status.link && !register.info.status.external"
          >
            {{ register.info.status.value }}
          </router-link>
          <a
            :class="`btn btn-sm btn-${register.info.status.class}`"
            v-else-if="
              register.info.status.external && register.info.status.link
            "
            :href="register.info.status.link"
            target="_blank"
            >{{ register.info.status.value }}</a
          >
          <div
            v-else
            class="value"
            :class="`text-${register.info.status.class}`"
          >
            {{ register.info.status.value }}
          </div>
        </div>
        <div
          class="col-md-2 col-lg-1 mt-3 mt-md-0 justify-content-md-end align-items-center d-flex"
        >
          <div v-for="(data, k) in register.actions" :key="k">
            <button
              v-if="data.action"
              class="btn btn-link"
              :disabled="data.disabled"
              :class="{ disabled: data.disabled }"
              v-on:click="acao(data.action, data.id)"
            >
              <i v-if="data.icon" class="material-icons">{{ data.icon }}</i>
              <span v-else>{{ data.label }}</span>
            </button>
            <router-link
              v-else-if="data.link"
              class="btn btn-link"
              :to="data.link"
              :class="{ disabled: data.disabled }"
              :disabled="data.disabled"
            >
              <i v-if="data.icon" class="material-icons">{{ data.icon }}</i>
              <span v-else>{{ data.label }}</span>
            </router-link>
            <router-link
              v-else
              class="btn btn-link"
              :to="data.link"
              :disabled="data.disabled"
              :class="{ disabled: data.disabled }"
            >
              <i v-if="data.icon" class="material-icons">{{ data.icon }}</i>
              <span v-else>{{ data.label }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ListaCadastrosPlano",
  props: {
    plan: {
      type: String,
      default: "",
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    acao(action, id) {
      this.$emit(action, id);
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 5px;
  line-height: 1.4;
}
.value {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
</style>
